'use strict'
/**
 * 路由级 SEO 元信息表（唯一事实来源）。
 *
 * 三处共用同一份数据，避免文案走样：
 *   1. 浏览器端：src/utils/seo.js 在路由切换时写入 <head>（title / description / canonical / OG / JSON-LD）
 *   2. 构建期：tools/seo/prerender.js 为每个路由产出独立静态 HTML，爬虫无需执行 JS 也可读到完整 head
 *   3. 构建期：tools/seo/generate-static.js 生成 sitemap.xml（sitemap !== false 的路由）
 *
 * 字段说明：
 *   path        路由路径（不含域名，作为 canonical 与 sitemap 的 URL 路径）
 *   name        站内名称（面包屑、锚点文案）
 *   title       完整页面标题（含品牌，不再二次拼接）
 *   description 页面描述（建议 60–120 字）
 *   keywords    页面关键词
 *   changefreq  sitemap 更新频率
 *   priority    sitemap 权重
 *   sitemap     是否写入 sitemap（个人中心等需登录页为 false）
 *   robots      覆盖默认 robots 指令（默认 index,follow）
 *   type        结构化数据页面类型（WebPage / CollectionPage / ContactPage …）
 *   crumbs      面包屑链路（不含“首页”，首页自动补）
 */

var site = require('./site')

/** 默认 robots（可被单条路由覆盖） */
var DEFAULT_ROBOTS = 'index,follow'
/** 需登录 / 无检索价值的页面 */
var PRIVATE_ROBOTS = 'noindex,follow'

var ROUTES = [
  {
    path: '/',
    name: '首页',
    title: site.defaultTitle,
    description: site.description,
    keywords: site.keywords,
    changefreq: 'weekly',
    priority: 1.0,
    type: 'WebPage'
  },
  {
    path: '/api',
    name: '数据产品',
    title: '数据产品 - 200+ 商业数据 API 接口与在线测试｜动态时序科技',
    description:
      '数据产品：17 大数据分类、200+ 标准/可定制化商业数据接口目录，覆盖工商、司法风险、经营风险、税务、知识产权等维度，提供接口文档示例（企业基本信息 1001）、在线接口测试与包年/包天/充值计费方式。',
    keywords:
      '数据产品,商业数据接口,API 接口目录,企业信息查询接口,在线接口测试,接口计费,' +
      site.businessKeywords + ',动态时序科技',
    changefreq: 'weekly',
    priority: 0.9,
    type: 'CollectionPage',
    crumbs: ['数据产品']
  },
  {
    path: '/allApi',
    name: '接口列表',
    title: '接口列表 - 商业数据 API 全量清单｜动态时序科技',
    description:
      '接口列表：按分类检索动态时序全部商业数据 API，覆盖工商、司法风险、经营风险、税务评级、知识产权、关联关系等 17 大类，可查看接口文档、示例代码并在线试调。',
    keywords:
      '接口列表,API 清单,商业数据接口,企业数据接口,接口检索,' +
      site.businessKeywords + ',动态时序科技',
    changefreq: 'weekly',
    priority: 0.8,
    type: 'CollectionPage',
    crumbs: ['数据产品', '接口列表']
  },
  {
    path: '/apiDetail',
    name: '接口详情',
    title: '接口详情 - 请求参数、返回字段与在线试调｜动态时序科技',
    description:
      '接口详情页：查看单个商业数据接口的接口 ID、请求方式、返回格式、请求参数表、返回字段说明、错误代码与示例代码，并可直接在线测试调用。',
    keywords: '接口详情,API 文档,请求参数,返回字段,接口试调,动态时序科技',
    changefreq: 'weekly',
    priority: 0.7,
    type: 'WebPage',
    crumbs: ['数据产品', '接口详情']
  },
  {
    path: '/consulting',
    name: '技术服务',
    title: '技术服务 - 数据规划、主数据治理与定制化数据获取｜动态时序科技',
    description:
      '技术服务：以“咨询 + 实施”方式提供数据规划、数据治理、主数据管理、数据资产盘点、指标体系建设与定制化数据获取等 6 类服务，附标杆案例与合作流程。',
    keywords:
      '数据技术服务,数据咨询,数据治理,主数据管理,数据资产盘点,指标体系,定制化数据服务,' +
      site.businessKeywords + ',动态时序科技',
    changefreq: 'monthly',
    priority: 0.8,
    type: 'Service',
    crumbs: ['技术服务']
  },
  {
    path: '/charge',
    name: '充值中心',
    title: '充值中心 - 按次调用与包年包天计费｜动态时序科技',
    description:
      '充值中心：充值余额可用于全部标准接口的按次调用，多档金额享赠送优惠；价格与赠送规则无需登录即可查看，支持包年、包天与充值三种计费方式。',
    keywords: '充值中心,接口计费,按次调用,包年接口,包天接口,动态时序科技',
    changefreq: 'monthly',
    priority: 0.6,
    type: 'WebPage',
    crumbs: ['充值中心']
  },
  {
    path: '/contact',
    name: '联系我们',
    title: '联系我们 - 产品咨询与商务合作｜动态时序科技',
    description:
      '联系我们：动态时序科技有限公司地址北京市海淀区北三环西路32号恒润国际大厦，商务邮箱 ' +
      site.email +
      '，欢迎产品咨询、方案定制与合作洽谈，我们将在 1 个工作日内回复。',
    keywords: '联系我们,商务合作,产品咨询,动态时序科技,联系方式',
    changefreq: 'monthly',
    priority: 0.7,
    type: 'ContactPage',
    crumbs: ['联系我们']
  },
  {
    path: '/aboutUs/case1',
    name: '关于我们',
    title: '关于我们 - 专注商业数据监控及调用服务｜动态时序科技',
    description:
      '关于我们：动态时序科技有限公司成立于 2021 年，专注商业数据监控及调用服务，以“数据 + AI”打造数据智能产品体系，客户覆盖水务、园林、医药、金融、高校等领域。',
    keywords: '关于我们,动态时序科技,公司简介,发展历程,数据服务商,商业数据,数据监控,数据服务',
    changefreq: 'monthly',
    priority: 0.7,
    type: 'AboutPage',
    crumbs: ['关于我们']
  },
  {
    path: '/aboutUs/case2',
    name: '用户协议',
    title: '用户协议｜动态时序科技',
    description:
      '用户协议：本协议由您与动态时序科技有限公司就动态时序官网及 API 数据平台提供的产品服务所订立，请在注册使用前仔细阅读。',
    keywords: '用户协议,服务条款,动态时序科技',
    changefreq: 'yearly',
    priority: 0.3,
    type: 'WebPage',
    crumbs: ['关于我们', '用户协议']
  },
  {
    path: '/aboutUs/case3',
    name: '隐私政策',
    title: '隐私政策｜动态时序科技',
    description:
      '隐私政策：说明动态时序科技如何收集、使用、存储与保护用户信息，以及您对个人信息享有的查询、更正与删除权利。',
    keywords: '隐私政策,个人信息保护,数据安全,动态时序科技',
    changefreq: 'yearly',
    priority: 0.3,
    type: 'WebPage',
    crumbs: ['关于我们', '隐私政策']
  },
  {
    path: '/aboutUs/case4',
    name: '认证服务协议',
    title: '认证服务协议｜动态时序科技',
    description:
      '认证服务协议：企业用户在动态时序官网及 API 数据平台提交认证信息时适用的服务条款与权责说明。',
    keywords: '认证服务协议,企业认证,动态时序科技',
    changefreq: 'yearly',
    priority: 0.3,
    type: 'WebPage',
    crumbs: ['关于我们', '认证服务协议']
  },
  {
    path: '/center/case1',
    name: '我的余额',
    title: '个人中心 - 我的余额｜动态时序科技',
    description: '登录后可查看账户余额、充值明细与消费记录。',
    robots: PRIVATE_ROBOTS,
    sitemap: false,
    type: 'WebPage'
  },
  {
    path: '/center/case2',
    name: '我的订单',
    title: '个人中心 - 我的订单｜动态时序科技',
    description: '登录后可查看订单列表与订单状态。',
    robots: PRIVATE_ROBOTS,
    sitemap: false,
    type: 'WebPage'
  },
  {
    path: '/center/case3',
    name: '我的接口',
    title: '个人中心 - 我的接口｜动态时序科技',
    description: '登录后可查看已申请接口、密钥与调用情况。',
    robots: PRIVATE_ROBOTS,
    sitemap: false,
    type: 'WebPage'
  },
  {
    path: '/center/case4',
    name: '企业认证',
    title: '个人中心 - 企业认证｜动态时序科技',
    description: '登录后可提交与查看企业认证信息。',
    robots: PRIVATE_ROBOTS,
    sitemap: false,
    type: 'WebPage'
  },
  {
    path: '/center/case5',
    name: '账号设置',
    title: '个人中心 - 账号设置｜动态时序科技',
    description: '登录后可维护账号资料与登录密码。',
    robots: PRIVATE_ROBOTS,
    sitemap: false,
    type: 'WebPage'
  }
]

/** 未收录路径（如 404）使用的兜底配置：保守地不索引 */
var FALLBACK = {
  path: '',
  name: '页面',
  title: '页面不存在 - 动态时序科技',
  description: site.description,
  keywords: site.keywords,
  robots: 'noindex,follow',
  sitemap: false,
  type: 'WebPage'
}

/** 带重定向的路径 → 正式路径（canonical / sitemap 一律指向正式路径） */
var ALIASES = {
  '/aboutUs': '/aboutUs/case1',
  '/center': '/center/case1',
  '/apiTest': '/api'
}

function normalize(pathname) {
  var path = String(pathname || '/').split('?')[0].split('#')[0]
  if (path.length > 1) path = path.replace(/\/+$/, '')
  return path || '/'
}

/** 按路径精确匹配路由配置；命中别名先转为正式路径；未命中返回 null */
function find(pathname) {
  var path = normalize(pathname)
  if (ALIASES[path]) path = ALIASES[path]
  for (var i = 0; i < ROUTES.length; i++) {
    if (ROUTES[i].path === path) return ROUTES[i]
  }
  return null
}

/** 解析路径对应的 SEO 配置，未收录路径返回兜底配置（noindex） */
function resolve(pathname) {
  var hit = find(pathname)
  if (hit) return hit
  var fallback = {}
  var keys = Object.keys(FALLBACK)
  for (var i = 0; i < keys.length; i++) fallback[keys[i]] = FALLBACK[keys[i]]
  fallback.path = normalize(pathname)
  return fallback
}

/** 生成绝对 canonical 地址（去掉查询串，避免同一内容多份 URL） */
function canonical(pathname) {
  var path = normalize(pathname)
  // 站点部署在子路径时，canonical 需要带上访问前缀（site.basePath，如 '/xxx/'）
  var full = (site.basePath || '') + path
  full = full.replace(/\/{2,}/g, '/')
  if (full.charAt(0) !== '/') full = '/' + full
  return site.url + full
}

/** 需要写入 sitemap 的路由（按 priority 倒序） */
function sitemapEntries() {
  return ROUTES.filter(function (route) {
    return route.sitemap !== false
  })
    .map(function (route) {
      return {
        loc: canonical(route.path),
        changefreq: route.changefreq || 'monthly',
        priority: typeof route.priority === 'number' ? route.priority : 0.5,
        lastmod: null
      }
    })
    .sort(function (a, b) {
      return b.priority - a.priority
    })
}

/** 预渲染需要产出的静态页面路径（含个人中心，保证直接访问可用） */
function prerenderPaths() {
  var paths = ['/']
  ROUTES.forEach(function (route) {
    if (route.path !== '/' && paths.indexOf(route.path) === -1) paths.push(route.path)
  })
  return paths
}

module.exports = {
  routes: ROUTES,
  aliases: ALIASES,
  defaultRobots: DEFAULT_ROBOTS,
  normalize: normalize,
  find: find,
  resolve: resolve,
  canonical: canonical,
  sitemapEntries: sitemapEntries,
  prerenderPaths: prerenderPaths
}



// WEBPACK FOOTER //
// ./src/seo/routes.js